import { type Translation } from 'primeng/api';

export const RU: Translation = {
  accept: 'Да',
  reject: 'Нет',
  clear: 'Очистить',
  apply: 'Применить',
  choose: 'Выбрать',
  upload: 'Загрузить',
  cancel: 'Отмена',
  today: 'Сегодня',
  weekHeader: 'Нед',
  firstDayOfWeek: 1,
  dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  dayNamesShort: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
  dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  monthNamesShort: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ],
  dateFormat: 'dd.mm.yy',
  emptyMessage: 'Нет данных',
};
